// Mostra a data de vencimento de uma atividade com cor + label semântico
// (Atrasada Xd, Hoje, Amanhã, Em N dias, ou data formatada). Cinza neutro
// quando a atividade já foi concluída/cancelada.
import { Typography } from 'antd';
import type { Atividade } from './types';

const { Text } = Typography;

interface Props {
  iso: string;
  status?: Atividade['status'];
}

export default function DataVencimento({ iso, status }: Props) {
  const data = new Date(iso);
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const diffDias = Math.floor((data.getTime() - hoje.getTime()) / (24 * 3600 * 1000));
  // Atividades concluídas ou canceladas NÃO devem aparecer como "atrasada" —
  // o prazo já não importa mais. Mostra só a data formatada em cinza.
  const finalizada = status === 'concluida' || status === 'cancelada';
  if (finalizada) {
    return <Text style={{ color: '#888', fontWeight: 400, fontSize: 11 }}>
      {data.toLocaleDateString('pt-BR')}
    </Text>;
  }
  const cor = diffDias < 0 ? '#B91626' : diffDias === 0 ? '#B07500' : diffDias <= 3 ? '#0930D0' : '#666';
  const label = diffDias < 0 ? `Atrasada (${Math.abs(diffDias)}d)` :
                diffDias === 0 ? 'Hoje' :
                diffDias === 1 ? 'Amanhã' :
                diffDias < 7 ? `Em ${diffDias} dias` :
                data.toLocaleDateString('pt-BR');
  return <Text style={{ color: cor, fontWeight: 500, fontSize: 11 }}>{label}</Text>;
}
